import { graphql, useStaticQuery } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";

type Tag = {
  uuid: string;
  name: string;
};

export const useBlogTags = (tagIds?: string[]) => {
  const { language, defaultLanguage } = useI18next();
  const { categories } = useStaticQuery(graphql`
    {
      categories: allStoryblokDatasourceEntry(
        filter: {
          data_source: { eq: "blog-tags" }
          data_source_dimension: { ne: null }
        }
      ) {
        group(field: { value: SELECT }) {
          edges {
            node {
              value
              optionKey: data_source_dimension
              option: dimension_value
            }
          }
        }
      }
    }
  `);

  const tags: Tag[] = categories.group.map((item) => ({
    uuid: item.edges[0].node.value,
    name:
      item.edges.filter((edge) => edge.node.optionKey === language)[0]?.node
        .option ??
      item.edges.filter((edge) => edge.node.optionKey === defaultLanguage)[0]
        ?.node.option ??
      item.edges[0].node.value,
  }));

  if (tagIds?.length) {
    return tags.filter((tag) => tagIds.includes(tag.uuid));
  }

  return tags;
};
